<template>
  <validation-observer tag="div" ref="form">
    <b-form-group label="Current Cash on Hand" label-class="text-block text-sm text-semibold text-neutral-default">
      <div class="text-block text-sm">
        {{ $numeral(model.initial_value).format("$ 0,0") }}
      </div>
    </b-form-group>
    <validation-provider
      vid="value"
      :name="lodash.upperFirst($t('constants.cash_on_hand'))"
      rules="required|numeric|min_value:0"
      v-slot="{ validated, errors }"
    >
      <b-form-group
        :label="lodash.startCase($t('constants.cash_on_hand'))"
        :invalid-feedback="errors[0]"
        :state="errors[0] ? false : validated ? true : null"
        class="row mb-3"
        label-cols-md="12"
        label-class="text-block text-sm text-semibold text-neutral-default"
      >
        <b-input-group>
          <numeral-input
            id="value"
            :key="`value`"
            v-model.number="model.value"
            :placeholder="`Rp 0`"
            :state="errors[0] ? false : validated ? true : null"
            format="$ 0,0.[00]"
            lazy-formatter
          />
        </b-input-group>
      </b-form-group>
    </validation-provider>
    <div class="auditable" v-if="model.updater">
      <div>Diperbarui pada: {{ $moment(model.updated_at).format("DD MMMM YYYY HH:mm:ss") }}</div>
      <div>Oleh: {{ model.updater.name }}</div>
    </div>
  </validation-observer>
</template>

<script>
import NumeralInput from "@/components/inputs/numeral";
export default {
  components: { NumeralInput },
  props: {
    value: Object,
    isValid: { type: Boolean, default: true },
    errors: {
      type: Object,
      default() {
        return {};
      }
    },
    alerts: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      loading: false,
      model: {
        value: 0,
        ...this.value
      },
      editorInit: {
        height: 512,
        image_title: true,
        automatic_uploads: true,
        file_picker_types: "image",
        file_picker_callback: this.editorFilePickerCallback,
        mobile: {
          inline: true
        }
      }
    };
  },
  mounted() {
    // this.fetchModel();
    this.$refs.form.setErrors({
      ...this.$refs.form.errors,
      ...this.errors
    });
  },
  watch: {
    errors(value) {
      this.$refs.form.setErrors(value);
    }
  },
  methods: {
    fetchModel() {
      this.loading = true;
      return this.$axios("/constants/cash_on_hand", {
        params: {
          with: "updater"
        }
      })
        .then(response => {
          const {
            data: { data }
          } = response;
          this.model = data;
        })
        .finally(() => (this.loading = false));
    },
    emitValue() {
      this.$emit("input", this.model);
    },
    validateAll() {
      return this.$refs.form
        .validate()
        .then(isValid => {
          if (isValid) this.emitValue();
          this.$emit("update:is-valid", isValid);
          this.$emit("update:form-errors", this.$refs.form.errors);
          const invalidFeedback = this.$el.querySelector(".invalid-feedback");
          if (invalidFeedback) {
            invalidFeedback.scrollIntoView({ behavior: "smooth", block: "center" });
            return false;
          }
          return isValid;
        })
        .catch(() => false);
    },
    editorFilePickerCallback(cb) {
      let vm = this;
      let input = document.createElement("input");
      input.setAttribute("type", "file");
      input.setAttribute("accept", "image/*");
      input.onchange = function() {
        let file = this.files[0];
        let reader = new FileReader();
        reader.onload = function() {
          let id = "blobid" + new Date().getTime();
          let blobCache = vm.$refs.editor.editor.editorUpload.blobCache;
          let base64 = reader.result.split(",")[1];
          let blobInfo = blobCache.create(id, file, base64);
          blobCache.add(blobInfo);

          cb(blobInfo.blobUri(), { title: file.name });
        };
        reader.readAsDataURL(file);
      };
      input.click();
    }
  }
};
</script>

<style scoped lang="scss">
.auditable {
  color: #6c7589;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
